import { createContext, useContext } from 'react';

export interface ListingResultsState {
  filterSearch: string;
  isFetching: boolean;
  isPending: boolean;
  isSelectAllPartial: boolean;
  isSelectingAll: boolean;
  itemsCount: number;
  numListingsTotal: number;
}

export const ListingResultsContext = createContext<ListingResultsState | null>(null);

export function useListingResults() {
  const state = useContext(ListingResultsContext);
  if (!state) throw new Error('useListingResults must be used inside ListingList');
  return state;
}
